import React from 'react';
import './Cali.css'; 

const Riohacha = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKRH.pdf" target="_blank" rel="noreferrer">Aeropuerto Almirante Padilla</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 10</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2F.pdf" target="_blank" rel="noreferrer">ATED2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2F.pdf" target="_blank" rel="noreferrer">BUXE1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2F.pdf" target="_blank" rel="noreferrer">VUP2M</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2F.pdf" target="_blank" rel="noreferrer">XUXO1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2F.pdf" target="_blank" rel="noreferrer">TIPG4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2F.pdf" target="_blank" rel="noreferrer">URIB2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP1N.pdf" target="_blank" rel="noreferrer">VUP1N</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP1N.pdf" target="_blank" rel="noreferrer">ATED1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP1N.pdf" target="_blank" rel="noreferrer">BUXE1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP1N.pdf" target="_blank" rel="noreferrer">TIPG1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP1N.pdf" target="_blank" rel="noreferrer">XUXO1F</a></th>
          </tr>
               
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 28</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP2Q.pdf" target="_blank" rel="noreferrer">VUP2Q</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP2Q.pdf" target="_blank" rel="noreferrer">ATED1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP2Q.pdf" target="_blank" rel="noreferrer">BUXE1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP2Q.pdf" target="_blank" rel="noreferrer">TIPG1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP2Q.pdf" target="_blank" rel="noreferrer">XUXO1E</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 10</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VUP1R.pdf" target="_blank" rel="noreferrer">VUP1R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2A.pdf" target="_blank" rel="noreferrer">ATED2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2A.pdf" target="_blank" rel="noreferrer">BUXE1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2A.pdf" target="_blank" rel="noreferrer">TIPG2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2A.pdf" target="_blank" rel="noreferrer">VUP1S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED2A.pdf" target="_blank" rel="noreferrer">XUXO2C</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 28</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED1C.pdf" target="_blank" rel="noreferrer">ATED1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED1C.pdf" target="_blank" rel="noreferrer">BUXE1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED1C.pdf" target="_blank" rel="noreferrer">TIPG1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED1C.pdf" target="_blank" rel="noreferrer">VUP1T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/ATED1C.pdf" target="_blank" rel="noreferrer">XUXO1D</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 10</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/VOR10.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/RNP10.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 28</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRH/RNP28.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Riohacha;